require('./site/bootstrap');

import Swiper from 'swiper';
require('swiper/dist/css/swiper.min.css');

window.Popper = require('popper.js');
import { Util, Modal } from 'bootstrap';

import JqueryMaskPlugin from 'jquery-mask-plugin';
require('jquery-mask-plugin');

$(function () {
	/*/
	 *  Scroll reveal
	/*/
		const ScrollReveal = require('scrollreveal')({
			distance: '50px',
			scale: 1,
			duration: 1000,
			reset: false,
			mobile: true,
			viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
			beforeReveal: function (domEl) {
		    	$(domEl).addClass('is-visible');
		    }
		});

		// default values
		ScrollReveal.reveal('.right-scrollreveal', { origin: 'right' });
		ScrollReveal.reveal('.left-scrollreveal', { origin: 'left' });
		ScrollReveal.reveal('.top-scrollreveal', { origin: 'top' });
		ScrollReveal.reveal('.bottom-scrollreveal', { origin: 'bottom' });
	
	/*/
	 *  Nav controls
	/*/
		$('.nav_in').click(function(){
			$('body').addClass('nav--open');
			//$("meta[name='theme-color']").attr('content', '#ea1b2e');
		});

		$('.nav_out').click(function(){
			$('body').removeClass('nav--open');
			$('header nav').animate({scrollTop: 0 }, 100);
			//$("meta[name='theme-color']").attr('content', '#ffffff');
		});

		$(document).keyup(function(e) {
		     if (e.keyCode == 27) {
		        $('body').removeClass('nav--open');
				$('header nav').animate({scrollTop: 0 }, 100);
				//$("meta[name='theme-color']").attr('content', '#ffffff');
		    }
		});

	/*/
	 *  Swiper
	/*/
		$(document).ready(function () {
		    var SwiperBanner = new Swiper ('#swiper-banner', {
		      	speed: 750,
		      	slidesPerView: 1,
			    effect: 'fade',
			    loop: true,
			    // autoplay: 3500,
			    // autoplayDisableOnInteraction: false,
			    pagination: '#banner_count',
			    paginationHide: false,
			    paginationType: 'fraction',			    
			    keyboardControl: true,
			    /*autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
			    pagination: {
			    	el: '#banner_count',
			        type: 'fraction',
			   	},
			   	keyboard: {
					enabled: true,
					onlyInViewport: false,
				}*/
		    });

		    var swiperDepoimentos = new Swiper ('#swiper-depoimentos', {
		      	speed: 750,
		      	slidesPerView: 1,
			    effect: 'fade',
			    loop: true,
			    /*autoplay: 3500,*/
			    autoHeight: true,	
			    pagination: '#depoimentos_count',
			    paginationHide: false,
			    paginationType: 'bullets',
			    paginationClickable: true,
			    keyboardControl: true,
			    /*pagination: {
			    	el: '.depoimentos_count',
			    	clickable: true
			   	}
			   	keyboard: {
					enabled: true,
					onlyInViewport: false,
				},*/
		    });
		 });

	/*/
	 *  Scroll down
	/*/
		$('.scroll_down').click(function() {
			$('html, body').animate({scrollTop: $('#scroll_down_anchor').offset().top}, 1000);
		});

	/*/
	 *  Form
	/*/	
		$('input[type="tel"]')
        	.mask("(99) 99999-9999");



    	 window.addEventListener('load', function() {
		    var forms = document.getElementsByClassName('needs-validation');
		    var validation = Array.prototype.filter.call(forms, function(form) {
		      form.addEventListener('submit', function(event) {
		        if (form.checkValidity() === false) {
		          event.preventDefault();
		          event.stopPropagation();

		          form.classList.add('was-validated');
		        } else {
		        	event.preventDefault();
		        	const button = document.getElementById('send');
					var originalText = button.innerText;

					button.disabled  = true;
					button.innerText = 'enviando...';

					var data = new FormData(form);

					window.axios.post(form.action, data)
						.then(response => {
							button.innerText = 'mensagem enviada!';
							document.getElementById('form-contact').reset();

							setTimeout(function () {
								button.disabled = false;
								button.innerText = originalText;
							}, 4000);
						})
						.catch(error => {
							button.innerText = 'erro, tente novamente.';
							setTimeout(function () {
								button.disabled  = false;
								button.innerText = originalText;
							}, 4000);
						});

		        }
		        
		      }, false);
		    });
		  }, false);


});
